import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";
import { matchSummaryContainer } from "../matchSummary.css";

const CONTAINER_BREAKPOINTS = {
  0: "550px",
  1: "650px",
};

export const matchGroup = style({
  flex: 1,
  gap: vars.space.xs,
  "@container": {
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[0]})`]: {
      selectors: {
        "&:not(:first-child)": {
          marginInlineStart: vars.space.xs,
          borderInlineStart: `1px solid ${vars.colors.outlineVariant}`,
          paddingInlineStart: vars.space.m,
        },
      },
    },
  },
});

export const matchUnit = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  gap: vars.space.xs,
  width: "100%",
  height: "100%",
});

export const matchListItem = style({
  alignSelf: "center",
  width: "100%",
  listStyle: "none",
  selectors: {
    // by default, hide items 4 onwards
    "&:nth-child(n+4)": {
      display: "none",
    },
  },
  "@container": {
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[0]})`]: {
      selectors: {
        // show the first 4 items
        "&:nth-child(-n+4)": {
          display: "flex",
        },
        // hide items 5 onwards
        "&:nth-child(n+5)": {
          display: "none",
        },
      },
    },
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[1]})`]: {
      selectors: {
        // show the first 5 items
        "&:nth-child(-n+5)": {
          display: "flex",
        },
      },
    },
  },
});

const matchListBase = style({
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: vars.space["2xs"],
  padding: 0,
  listStyle: "none",
  "@container": {
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[0]})`]: {
      gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    },
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[1]})`]: {
      gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    },
  },
});

export const matchList = styleVariants({
  ltr: [matchListBase, { direction: "ltr" }],
  rtl: [matchListBase, { direction: "rtl" }],
});

export const titleStyles = style({
  marginBottom: vars.space.xs,
  fontSize: vars.fontSizes.body.s,
});

export const blankMatch = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: 32,
});

export const matchRound = style({
  color: vars.colors.onSurfaceVariant,
  fontSize: vars.fontSizes.body.xs,
});

export const badgeContainer = style({
  padding: `0 ${vars.space.xs}`,
  width: 56,
  height: 32,
  "@container": {
    [`${matchSummaryContainer} (min-width: ${CONTAINER_BREAKPOINTS[0]})`]: {
      padding: `0 ${vars.space.s}`,
    },
  },
});

export const baseMatchChip = style({
  borderRadius: `0 0 ${vars.radii.s} ${vars.radii.s}`,
  width: "100%",
  textAlign: "center",
  color: "inherit",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const teamContainer = style({
  textAlign: "center",
});

export const teamName = style({
  textWrap: "nowrap",
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const matchChip = styleVariants({
  default: [baseMatchChip, { backgroundColor: vars.colors.tonal }],
  1: [baseMatchChip, vars.colors.difficulties[1]],
  2: [baseMatchChip, vars.colors.difficulties[2]],
  3: [baseMatchChip, vars.colors.difficulties[3]],
  4: [baseMatchChip, vars.colors.difficulties[4]],
  5: [baseMatchChip, vars.colors.difficulties[5]],
});
